import React, { useState } from "react";
import { ISAD_LEVELS, ISAD_CONFIG, NO_DATA_COLOR } from "../models/isad";

const ENTRIES = [
  ...ISAD_LEVELS.map((level) => ({
    level,
    color: ISAD_CONFIG[level].color,
    label: `${level} — ${ISAD_CONFIG[level].label}`,
    dashed: false,
  })),
  { level: null, color: NO_DATA_COLOR, label: "No data", dashed: true },
];

const ISADLegend = ({ isDark = false }) => {
  const [collapsed, setCollapsed] = useState(false);

  const bg = isDark ? "rgba(17,24,39,0.92)" : "rgba(255,255,255,0.95)";
  const border = isDark ? "#374151" : "#e5e7eb";
  const titleColor = isDark ? "#f9fafb" : "#111827";
  const textColor = isDark ? "#d1d5db" : "#374151";

  return (
    <div
      role="region"
      aria-label="ISAD level legend"
      style={{
        background: bg,
        border: `1px solid ${border}`,
        borderRadius: 10,
        padding: "10px 12px",
        minWidth: 160,
        boxShadow: "0 1px 4px rgba(0,0,0,0.10)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 0,
        }}
      >
        <span style={{ fontSize: 12, fontWeight: 700, color: titleColor }}>
          ISAD level
        </span>
        <button
          onClick={() => setCollapsed((c) => !c)}
          aria-label={collapsed ? "Expand ISAD legend" : "Collapse ISAD legend"}
          aria-expanded={!collapsed}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: textColor,
            fontSize: 14,
            padding: "0 0 0 8px",
            lineHeight: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          <span
            style={{
              display: "inline-block",
              transform: collapsed ? "rotate(-90deg)" : "rotate(0deg)",
              transition: "transform 0.22s ease",
            }}
          >
            ▾
          </span>
        </button>
      </div>

      <div
        style={{
          overflow: "hidden",
          maxHeight: collapsed ? 0 : 200,
          opacity: collapsed ? 0 : 1,
          marginTop: collapsed ? 0 : 8,
          transition: "max-height 0.25s ease, opacity 0.2s ease, margin-top 0.25s ease",
        }}
      >
        <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
          {ENTRIES.map(({ level, color, label, dashed }) => (
            <li
              key={level ?? "nodata"}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginBottom: 5,
              }}
            >
              <span
                aria-hidden="true"
                style={{
                  width: 16,
                  height: 10,
                  borderRadius: 2,
                  flexShrink: 0,
                  background: dashed ? "transparent" : color,
                  border: dashed ? `2px dashed ${color}` : "none",
                }}
              />
              <span style={{ fontSize: 11, color: textColor }}>{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ISADLegend;
